import {Link} from 'react-router-dom';
import KindTile from './KindTile';
import {kindInfo} from '../../lib/kinds';
import {formatDateShort} from '../../lib/when';
import {Post} from '../../types';

// The compact row for scanning: a thumbnail or kind tile, the title, then date · place.
// Used by the filter view and the recently-deleted list.
export default function TellRow({post, to, trailing}: {post: Post; to?: string; trailing?: React.ReactNode}) {
    const thumb = post.photos[0]?.thumbUrl ?? post.photos[0]?.url ?? null;
    const inner = (
        <>
            {thumb ? <img src={thumb} alt="" loading="lazy" className="h-12 w-12 shrink-0 rounded-[12px] object-cover" /> : <KindTile kind={post.kind} size={48} />}
            <span className="min-w-0 flex-1">
                <span className="block truncate font-semibold">{post.title || kindInfo(post.kind).label}</span>
                <span className="meta block truncate">
                    {kindInfo(post.kind).label}
                    {post.detail ? ` · ${post.detail}` : ''} · {formatDateShort(post.whenLocal)}
                    {post.place ? ` · ${post.place.name}` : ''}
                </span>
            </span>
            {trailing}
        </>
    );
    const cls = 'flex min-h-[64px] items-center gap-3 py-2';
    return to ? (
        <Link to={to} className={`${cls} no-underline`}>
            {inner}
        </Link>
    ) : (
        <div className={cls}>{inner}</div>
    );
}
